
import "../styles/success_model.css";

function SuccessModal({ show, onClose }) {
  if (!show) return null;

  return (
    <div className="modal-backdrop-custom">
      <div className="modal-content-custom">
        <div className="text-center">
          <div className="mb-4">
            <svg
              width="60"
              height="60"
              fill="#e7e7e7"
              viewBox="0 0 16 16"
              className="bi bi-check-circle-fill"
            >
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.97 11.03a.75.75 0 0 0 1.07 0l4-4a.75.75 0 0 0-1.06-1.06L7.5 9.44 5.53 7.47a.75.75 0 0 0-1.06 1.06l2.5 2.5z" />
            </svg>
          </div>
          <h4 className="text-white fw-bold">Success</h4>
          <p className="text-white-50">Your message was successfully sent!</p>
          <button className="primary-dark-btn mt-3 px-4" onClick={onClose}>
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuccessModal;
